/**
 * Copy of `request` for another URL with its body buffered. `new Request(url,
 * request)` hands the source body over as a ReadableStream, which WebKit
 * (every iOS browser) rejects with "ReadableStream uploading is not supported".
 * The source body is consumed, so pass a clone when the original is still needed.
 */
export async function retargetRequest(request: Request, url: string | URL) {
  return new Request(url.toString(), {
    method: request.method,
    headers: request.headers,
    body: request.body ? await request.arrayBuffer() : null,
    signal: request.signal,
    credentials: request.credentials,
    cache: request.cache,
    redirect: request.redirect,
  });
}
